var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shfw-wrapper",style:({width:_vm.width*0.2994+'px'})},[_c('div',{staticClass:"shfw-head"},[_vm._v("社区生活服务")]),_c('div',{attrs:{"id":"chart-huan"}})])}
var staticRenderFns = []

export { render, staticRenderFns }